// NOTE — placement deviation, deliberate. The codebase precedent for local fixture modules is a
// colocated `__mocks__/` folder (e.g. `containers/Customer/__mocks__/Customer.mock.ts`). These
// fixtures live in `fixtures/` instead because they ship in the production bundle: `__mocks__/` is
// special to jest's module resolution and is the wrong home for shipped data. Customer Insights has
// no backend yet, so these payloads are the screen's only data source until the seam in
// `data/useCardData.ts` is swapped for SWR. PLA-8815.
//
// This module is the aggregator: one file per screen section under `cards/`, spread here in the
// section order of `registry/sections.ts`. `cardFixtures` stays the single entry point so
// `data/cardCache.ts` never learns the layout.
//
// Every card resolves `ok` here, so the screen can be reviewed with a full body on all 27. The
// degraded payloads are not gone: they live in `cards/dataStates.ts` and are spread over this map to
// put a state back on screen. The state-handling code they exercise is untouched.

import { IntelligenceFixture } from '../types';
import { behaviourEngagementCardFixtures } from './cards/behaviourEngagement';
import { customerBaseCardFixtures } from './cards/customerBase';
import { experienceValueCardFixtures } from './cards/experienceValue';
import { growthOpportunitiesCardFixtures } from './cards/growthOpportunities';
import { industryCardFixtures } from './cards/industry';
import { paymentsCardFixtures } from './cards/payments';
import { productReadinessCardFixtures } from './cards/productReadiness';
import { rewardsLoyaltyCardFixtures } from './cards/rewardsLoyalty';
import { riskProtectionCardFixtures } from './cards/riskProtection';

const sectionFixtureModules: Array<Record<string, IntelligenceFixture>> = [
  customerBaseCardFixtures,
  behaviourEngagementCardFixtures,
  experienceValueCardFixtures,
  rewardsLoyaltyCardFixtures,
  riskProtectionCardFixtures,
  industryCardFixtures,
  paymentsCardFixtures,
  productReadinessCardFixtures,
  growthOpportunitiesCardFixtures
];

// Merged with a collision check rather than spread: a card key repeated across two section modules
// would be a last-writer-wins drop, and the losing card would silently resolve to another band's
// payload — a shape `Record<string, IntelligenceFixture>` cannot make a type error.
export const cardFixtures: Record<string, IntelligenceFixture> = sectionFixtureModules.reduce(
  (merged, moduleFixtures) => {
    Object.keys(moduleFixtures).forEach(cardKey => {
      if (Object.prototype.hasOwnProperty.call(merged, cardKey)) {
        throw new Error(`Duplicate Intelligence fixture for card "${cardKey}"`);
      }

      merged[cardKey] = moduleFixtures[cardKey];
    });

    return merged;
  },
  {} as Record<string, IntelligenceFixture>
);
